import React from 'react';
import { FieldProps } from 'formik';
import { TextField as MuiTextField } from '@mui/material';

interface Props extends FieldProps {
  id: string;
  label: string;
  type: string;
  className: string;
  variant: any;
  fullWidth: boolean;
  value: string;
  multiline: boolean;
  rows: number;
  InputProps: any;
  disabled: boolean;
  hidden: boolean;
};

const TextField: React.FC<Props> = (
  { fullWidth, id, label, variant, multiline, rows, type, className, field, InputProps, disabled, hidden }
) => {
  return (
    <MuiTextField
      fullWidth={fullWidth}
      id={id}
      label={label}
      variant={variant}
      type={type}
      className={className}
      multiline={multiline}
      rows={rows}
      {...field}
      InputProps={InputProps}
      disabled={disabled}
      hidden={hidden}
    />
  );
};

export default TextField;

